import { render, staticRenderFns } from "./PcAdvisorSideNavigation.vue?vue&type=template&id=8d4514b0&scoped=true"
import script from "./PcAdvisorSideNavigation.vue?vue&type=script&lang=js"
export * from "./PcAdvisorSideNavigation.vue?vue&type=script&lang=js"
import style0 from "./PcAdvisorSideNavigation.vue?vue&type=style&index=0&id=8d4514b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4514b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VNavigationDrawer,VRow,VTextField})
